<template>
  <div>
    <el-drawer
      :title="this.$route.meta.title"
      :visible.sync="drawer"
      :direction="direction"
      :before-close="handleClose"
      size="45%"
    >
      <el-row style="margin: 30px">
        <el-transfer
          v-model="selected"
          :data="tablecolumn"
          :titles="['不显示', '显示']"
          @change="rowchange"
        ></el-transfer
      ></el-row>
      <el-row style="margin: 30px">
        <el-button type="primary" @click="submit">提交</el-button>
      </el-row>
    </el-drawer>
  </div>
</template>

<script>
import {
  userTableHeaderadd,
  userTableHeaderpagelist,
  userTableHeaderupdate,
} from "@/api/orgin";
import { getname } from "@/utils/auth";
export default {
  name: "TableHeader",
  props: {
    tablecolumn: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      drawer: false,
      direction: "rtl",
      selected: [],
      tablerow: [],
      inputtype: 1,
      form: {},
    };
  },
  mounted() {
    this.getrow();
  },
  methods: {
    getrow() {
      userTableHeaderpagelist({
        pageIndex: 1,
        pageSize: 10,
        uuid: "",
        user_name: getname(),
        module: this.$route.name,
        table_name: "",
        header_names: "",
        status: 1,
        creator: "",
      }).then((response) => {
        this.tablerow = [];
        if (response.data.listItems.length) {
          this.form = response.data.listItems[0];
          this.selected = response.data.listItems[0].header_names.split(",");
          this.inputtype = 2;
          let arr = response.data.listItems[0].header_names.split(",");
          for (let i = 0; i < arr.length; i++) {
            this.tablecolumn.find((item) => {
              if (item.key === arr[i]) {
                this.tablerow.push(item);
              }
            });
          }
        } else {
          this.tablerow = this.tablecolumn;
        }
        this.$parent.getrowshow();
      });
    },
    handleClose(val) {
      console.log(val);
      this.drawer = false;
    },
    rowchange(val) {
      console.log(val);
    },
    // 提交数据
    submit() {
      if (this.selected.length == 0) {
        this.$message({
          type: "warning",
          message: "至少选择一个字段",
        });
        return;
      }
      switch (this.inputtype) {
        case 1:
          userTableHeaderadd({
            uuid: "",
            user_name: getname(),
            module: this.$route.name,
            table_name: "",
            header_names: this.selected.toString(),
            status: 1,
            creator: "",
          }).then((response) => {
            console.log(response);
            this.getrow();
            this.$message({
              type: "success",
              message: "新增成功!",
            });
          });
          break;
        case 2:
          this.form.header_names = this.selected.toString();
          if (this.form.header_names[0] == ",") {
            this.form.header_names = this.form.header_names.substr(1);
            console.log(this.form.header_names);
          }

          userTableHeaderupdate(this.form).then((response) => {
            this.getrow();
            console.log(response);
            this.$message({
              type: "success",
              message: "修改成功!",
            });
          });
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
